// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"c6aaec6a","154":"c6aaec6a","414":"3d9aff9f","730":"5846c71c","788":"79b0f997","878":"abea5131","884":"28c0af69"}[chunkId] + ".chunk.css";
};